import { render, staticRenderFns } from "./app-authorization-dialog.vue?vue&type=template&id=231b4e5a&scoped=true&"
import script from "./app-authorization-dialog.vue?vue&type=script&lang=js&"
export * from "./app-authorization-dialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "231b4e5a",
  null
  
)

export default component.exports